import { render, staticRenderFns } from "./Sendsms.vue?vue&type=template&id=13dcd482"
import script from "./Sendsms.vue?vue&type=script&lang=js"
export * from "./Sendsms.vue?vue&type=script&lang=js"
import style0 from "./Sendsms.vue?vue&type=style&index=0&id=13dcd482&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports